import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import BrandNav from "../components/BrandNav";
import { useAuth } from "../lib/auth";
import { extractError } from "../lib/format";

export default function Signup() {
  const { t } = useTranslation("common");
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({
    parent_name: "",
    child_name: "",
    child_age: 8,
    country: "",
    email: "",
    password: "",
  });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: k === "child_age" ? Number(e.target.value) : e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await register(form);
      toast.success(t("auth.signup.toastSuccess"));
      nav("/pick-band", { replace: true });
    } catch (e) {
      setErr(extractError(e, t("auth.signup.errorFallback")));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="signup-page">
      <BrandNav />
      <main className="ftg-shell ftg-page">
        <div className="ftg-auth">
          <h1>{t("auth.signup.title")}</h1>
          <p className="ftg-auth__sub">{t("auth.signup.sub")}</p>
          <form className="ftg-form" onSubmit={submit} data-testid="signup-form">
            <div className="ftg-field">
              <label className="ftg-field__label" htmlFor="s-parent">{t("auth.signup.parentName")}</label>
              <input id="s-parent" className="ftg-field__input" required value={form.parent_name} onChange={set("parent_name")} data-testid="signup-parent-input" />
            </div>
            <div className="ftg-field">
              <label className="ftg-field__label" htmlFor="s-child">{t("auth.signup.childName")}</label>
              <input id="s-child" className="ftg-field__input" required value={form.child_name} onChange={set("child_name")} data-testid="signup-child-input" />
            </div>
            <div className="ftg-field">
              <label className="ftg-field__label" htmlFor="s-age">{t("auth.signup.childAge")}</label>
              <input id="s-age" className="ftg-field__input" type="number" min="5" max="18" required value={form.child_age} onChange={set("child_age")} data-testid="signup-age-input" />
            </div>
            <div className="ftg-field">
              <label className="ftg-field__label" htmlFor="s-country">{t("auth.signup.country")}</label>
              <input id="s-country" className="ftg-field__input" required value={form.country} onChange={set("country")} data-testid="signup-country-input" />
            </div>
            <div className="ftg-field">
              <label className="ftg-field__label" htmlFor="s-email">{t("auth.email")}</label>
              <input id="s-email" className="ftg-field__input" type="email" required value={form.email} onChange={set("email")} autoComplete="email" data-testid="signup-email-input" />
            </div>
            <div className="ftg-field">
              <label className="ftg-field__label" htmlFor="s-pw">{t("auth.signup.passwordLabel")}</label>
              <input id="s-pw" className="ftg-field__input" type="password" minLength={8} required value={form.password} onChange={set("password")} autoComplete="new-password" data-testid="signup-password-input" />
              <span className="ftg-field__hint">{t("auth.signup.passwordHint")}</span>
            </div>
            {err ? <div className="ftg-form__error" data-testid="signup-error">{err}</div> : null}
            <button type="submit" disabled={busy} className="ftg-btn ftg-btn--primary ftg-btn--large ftg-btn--block" data-testid="signup-submit-btn">
              {busy ? t("auth.signup.submitBusy") : t("auth.signup.submitIdle")}
            </button>
          </form>
          <div className="ftg-auth__foot">
            {t("auth.signup.haveAccount")} <Link to="/login" data-testid="signup-login-link">{t("auth.signup.signInLink")}</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
